// AISparkle.js — the four-point star that marks an AI-assisted surface (v3).
// HARD RULE (design-system-binding §6 / audit F-03·F-05·F-06): render ONLY
// where a real AI assist runs — market analysis (marketAnalysis.js), SoS
// generation (sosAI.js), assumptions (assumptionsAI.js). A deterministic
// calculation (GM-floor check, crossover, edit diff) must NOT carry a sparkle.
// Faithful port of components/brand/AISparkle.jsx.
import React from 'react';
import { v3 } from '../../lib/styleTokens';

export function AISparkle({ size = 14, color = v3.color.ink, style = {} }) {
  return (
    <svg width={size} height={size} viewBox="0 0 12 12" style={{ flex: '0 0 auto', ...style }}>
      <path d="M6 1 L7 5 L11 6 L7 7 L6 11 L5 7 L1 6 L5 5 Z" fill={color} />
    </svg>
  );
}
